import React from "react";
import useTasksKanbanListeners from "src/hooks/api/tasks/useTasksKanbanListeners";
import useUnreadsListener from "src/hooks/api/useUnreadsListener";

const ListenerProvider = () => {
	useTasksKanbanListeners();
	useUnreadsListener();

	return <></>;
};

export default ListenerProvider;
